import { render } from "./ImprestJournal.vue?vue&type=template&id=1079ce8a"
import script from "./ImprestJournal.vue?vue&type=script&lang=js"
export * from "./ImprestJournal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__